import { useContext } from "react";
import rightCaretImage from "../../assets/icons/right-caret.png";
import { LangContext } from "../../App";

export default function VerticalTab({ style = {}, label, isActive, onClick } : { style : any, label : string, isActive : boolean, onClick : any}) {
  const { lang } = useContext(LangContext);
  return (
    <div className="vertical-tab" style={style}>
      <div
        role="button"
        onClick={onClick}
        className={`vertical-tab__label ${isActive ? "color--primary" : ""}`}
        title={`Show ${label} tab`}
      >
        {label}
      </div>
      {isActive && (
        <img src={rightCaretImage} alt="" className={`vertical-tab__icon ${lang ? "rtl" : ""}`} />
      )}
    </div>
  );
}
